export default __webpack_public_path__ + "static/media/clock.dae65af1.svg";